import { createContext, useContext, ReactNode } from 'react';

export interface Repository {
    id: string;
    name: string;
    fullPath: string;
    ownerType: string;
    ownerId: string;
    description?: string;
    isPrivate: boolean;
    defaultBranch: string;
    sizeBytes: number;
    createdAt: string;
    updatedAt: string;
    /** 当前用户是否可管理仓库（协作者、危险操作等） */
    canAdmin?: boolean;
}

export interface Branch {
    name: string;
    sha: string;
    isDefault: boolean;
    updatedAt: string;
}

/** 若 defaultBranch 在分支列表中不存在（如只 push 了 dev 而 DB 仍是 main），则用第一个分支避免 404 */
export function resolveDefaultBranch(defaultBranch: string, branches: Branch[]): string {
    if (branches.some((b) => b.name === defaultBranch)) return defaultBranch;
    return branches[0]?.name ?? defaultBranch;
}

export interface RepoContextValue {
    repoPath: string;
    repo: Repository | null;
    branches: Branch[];
    currentBranch: string;
    setCurrentBranch: (name: string) => void;
    defaultBranch: string;
    cloneUrl: string;
    loading: boolean;
    error: string | null;
    refetch: () => Promise<void>;
}

const RepoContext = createContext<RepoContextValue | null>(null);

export function useRepoContext(): RepoContextValue | null {
    return useContext(RepoContext);
}

export function RepoProvider({
    value,
    children,
}: {
    value: RepoContextValue;
    children: ReactNode;
}) {
    return (
        <RepoContext.Provider value={value}>
            {children}
        </RepoContext.Provider>
    );
}
